import React from 'react';
import './SocialNetworks.scss';
import LinkComponent from './LinkComponent/LinkComponent';
import { socialNetData } from '../../Data/contactData';

function SocialNetworks() {
  return (
    <div className='contact-social'>
      <h3 className='contact-social--title'>
        social<span>.</span>
      </h3>
      <ul className='contact-social--links'>
        {socialNetData.map((socialNet, index) => (
          <LinkComponent
            key={index}
            name={socialNet.name}
            link={socialNet.link}
            icon={socialNet.icon}
          />
        ))}
      </ul>
    </div>
  );
}

export default SocialNetworks;
